import { useEffect } from "react";
import { useGameStore } from "../../store/gameStore";
import { playSfxByTag } from "../../lib/soundBus";
import { MessageCircleWarning } from "lucide-react";

// GM-only blinking banner: a player chose "Talk to GM" instead of rolling on a trap/trigger
// popup, so the outcome is left for the GM to narrate/resolve by hand rather than auto-rolling.
// Dismiss just clears the ping; "Open Whispers" jumps the GM straight to that player's thread.
export default function TalkToGmBanner({ isGm, gameId, onOpenWhispers }) {
  const pending = useGameStore((s) => s.talkToGmPing);
  const setPending = useGameStore((s) => s.setTalkToGmPing);

  // A light medium->high "chuckle" chime whenever a NEW ping lands, so the GM notices even if
  // they're not looking at the map right now.
  useEffect(() => {
    if (isGm && pending) playSfxByTag(gameId, "talk_to_gm_chime");
  }, [isGm, pending, gameId]);

  if (!isGm || !pending) return null;

  return (
    <div
      data-testid="talk-to-gm-banner"
      className="absolute top-4 left-1/2 -translate-x-1/2 z-30 flex items-center gap-3 bg-[#322216]/95 border-2 border-[#D4AF37] rounded-full px-4 py-2 shadow-xl animate-pulse"
    >
      <MessageCircleWarning className="w-4 h-4 text-[#D4AF37] shrink-0" />
      <span className="text-xs text-[#f1e0c5]/90">
        <strong className="text-[#D4AF37]">{pending.member_name || "A player"}</strong> wants to talk about: {pending.label}
        {pending.roll_result && (
          <span data-testid="talk-to-gm-roll-result" className={pending.roll_result.pass ? "text-[#4d7c0f]" : "text-[#D90429]"}>
            {" "}(rolled {pending.roll_result.total} — {pending.roll_result.pass ? "Success" : "Failed"})
          </span>
        )}
      </span>
      <button
        data-testid="talk-to-gm-open-whispers-button"
        onClick={() => { onOpenWhispers?.(); setPending(null); }}
        className="rounded-full h-7 px-3 text-xs bg-[#D90429] hover:bg-[#b8031f] text-white"
      >
        Open Whispers
      </button>
      <button data-testid="talk-to-gm-dismiss-button" onClick={() => setPending(null)} className="text-[#f1e0c5]/40 hover:text-white text-xs">
        Dismiss
      </button>
    </div>
  );
}
